import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ICDAuxCheckboxModel } from "./icd-aux-checkbox.model";
import { ICDBaseModel } from "./icd-base.model";

export class ICDSpinnerModel extends ICDBaseModel {
  public auxModel: ICDAuxCheckboxModel = new ICDAuxCheckboxModel();
  private _value: CubiqTS.BigNumber;
  public textValue: string;
  public skipInitValue: boolean = false;

  constructor() {
    super();
  }
  public override get value(): CubiqTS.BigNumber {
    return this._value;
  }
  public set value(value: CubiqTS.BigNumber) {
    this._value = value;
  }
}
